export const WaitingToAccept = 'WaitingToAccept';
export const PendingPayment = 'PendingPayment';
export const Accepted = 'Accepted';
export const Rejected = 'Rejected';
export const Cancelled = 'Cancelled';
export const Paid = 'Paid';
